module.exports = __webpack_public_path__ + "static/navavarn-ee26dad20c6369eb94b35ca56da898bd.jpg";